import { Button } from '@monksflow/monks-ui';
import { ListFilterIcon } from 'lucide-react';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

export interface TableFilterIconProps extends ComponentProps<'button'> {
  /** Column name, interpolated into the accessible label. */
  label: string;
  /** Raises the dot badge, marking the column as currently filtered. */
  isActive?: boolean;
}

export function TableFilterIcon({
  label,
  isActive = false,
  className,
  ...props
}: TableFilterIconProps) {
  const { t } = useTranslation('common');

  return (
    <Button
      {...props}
      variant="ghost"
      size="icon-mini"
      aria-label={t('components.tableFilterIcon.filter', { label })}
      className={twMerge('relative ml-1 size-5', className)}
    >
      <ListFilterIcon className="size-4" />
      {isActive && (
        <span
          data-testid="table-filter-active-dot"
          className="absolute top-0 right-0 size-1.5 rounded-full bg-primary"
        />
      )}
    </Button>
  );
}
